import request from '@/utils/zsm-requets'
const good='/zsm/api/goodLink/'
/**
 * 删除关联产品
@param id
 **/

export function deleteGoodLink(id) {
  return request({
    url: good+'delete',
    method: 'post',
    params:{id}
  })
}

/* 创建关联产品
  cover 封面
   title 标题
 */
export function createGoodLink(params) {
  return request({
    url: good+'create',
    method: 'post',
    params
  })
}

/* 获取关联产品列表
 */
export function listDataGoodLink(params) {
  return request({
    url: good+'listData',
    method: 'post',
    params
  })
}


/*
  修改关联产品
 */
export function updateGoodLink(params) {
  return request({
    url: good+'update',
    method: 'post',
    params
  })
}
